import { render, staticRenderFns } from "./KreirajGrupu.vue?vue&type=template&id=4e5e7b2f&scoped=true&"
import script from "./KreirajGrupu.vue?vue&type=script&lang=js&"
export * from "./KreirajGrupu.vue?vue&type=script&lang=js&"
import style0 from "./KreirajGrupu.vue?vue&type=style&index=0&id=4e5e7b2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e7b2f",
  null
  
)

export default component.exports